import type { Outcome } from '@competa/shared';

/** Erfolgsstufen, die in der Ergebnisansicht als Kontrollkästchen angeboten werden. */
export const SUCCESS_LEVELS = ['acceptance', 'honorable_mention', 'medal'] as const;

/** Übersetzungsschlüssel (ohne Präfix) je Ergebnis. */
export const OUTCOME_KEYS: Record<Outcome, string> = {
  open: 'open',
  rejected: 'rejected',
  acceptance: 'acceptance',
  honorable_mention: 'honorableMention',
  medal: 'medal',
};

/**
 * Berechnet das Ergebnis nach dem Umschalten eines Kontrollkästchens. Die Stufen schließen sich aus:
 * Anklicken setzt genau diese Stufe, Abwählen der gesetzten Stufe setzt das Ergebnis auf „offen".
 * @param current Bisheriges Ergebnis.
 * @param level Umgeschaltete Stufe.
 * @returns Neues Ergebnis.
 */
export function toggleLevel(current: Outcome, level: (typeof SUCCESS_LEVELS)[number]): Outcome {
  return current === level ? 'open' : level;
}
